module.exports = __webpack_public_path__ + "img/manutd3.7a1b4c3d.jpg";